import { Component, Prop, Vue } from 'vue-property-decorator'
import ConfigurationRelationships
    from '@/modules/configurationModule/shared/components/configuration-relationships/configuration-relationships.vue'
import { ConfigurationPersonnelResponse } from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel/configuration-personnel.dto'
import {
    ConfigurationAutomationPersonnelEntitiesAssociationModalMostLikelyMorphologicCodeAssignmentFormState,
    initialConfigurationAutomationPersonnelEntitiesAssociationModalMostLikelyMorphologicCodeAssignmentFormState
} from '@/modules/configurationModule/detail/automation/personnel/entities-association/components/modal-most-likely-morphologic-code-assignment-form/configuration-automation-personnel-entities-association-modal-most-likely-morphologic-code-assignment-form.model'
import { CommonMostLikelyMorphologicCodeResponse } from '@/api/services/common/most-likely-morphologic-code/common-most-likely-morphologic-code.dto'
import { commonMostLikelyMorphologicCodeService } from '@/api/services/common/most-likely-morphologic-code/common-most-likely-morphologic-code.service'
import {
    ConfigurationPersonnelMostLikelyMorphologicCodeAssignmentCreateRequest,
    ConfigurationPersonnelMostLikelyMorphologicCodeAssignmentResponse
} from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel-most-likely-morphologic-code-assignment/configuration-personnel-most-likely-morphologic-code-assignment.dto'
import { configurationPersonnelMostLikelyMorphologicCodeAssignmentService } from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel-most-likely-morphologic-code-assignment/configuration-personnel-most-likely-morphologic-code-assignment.service'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'
import { GridUtils } from '@/shared/util/grid-utils'

@Component({
    components: {
        ConfigurationRelationships
    }
})
export default class ConfigurationAutomationPersonnelEntitiesAssociationModalMostLikelyMorphologicCodeAssignmentForm extends Vue {
    @Prop(String) readonly actionTitle!: string
    @Prop() readonly personnel!: ConfigurationPersonnelResponse

    state: ConfigurationAutomationPersonnelEntitiesAssociationModalMostLikelyMorphologicCodeAssignmentFormState
    constructor() {
        super()
        this.state = initialConfigurationAutomationPersonnelEntitiesAssociationModalMostLikelyMorphologicCodeAssignmentFormState()
    }

    private async _loadMostLikelyMorphologicCodes(): Promise<void> {
        this.state.mostLikelyMorphologicCodes = await this._getMostLikelyMorphologicCodes()
    }

    private async _loadPersonnelMostLikelyMorphologicCodeAssignments(): Promise<void> {
        this.state.personnelMostLikelyMorphologicCodeAssignments = await this._getPersonnelMostLikelyMorphologicCodeAssignments()
    }

    async mounted() {
        await this._loadMostLikelyMorphologicCodes()
        await this._loadPersonnelMostLikelyMorphologicCodeAssignments()
    }

    /// SERVICES CALLS ///

    private async _getMostLikelyMorphologicCodes(): Promise<CommonMostLikelyMorphologicCodeResponse[]> {
        const response = await this.$_toCallUnique(commonMostLikelyMorphologicCodeService.getMostLikelyMorphologicCodes())
        if (response) {
            return response
        }
        return []
    }

    private async _getPersonnelMostLikelyMorphologicCodeAssignments(): Promise<ConfigurationPersonnelMostLikelyMorphologicCodeAssignmentResponse[]> {
        const filterModel: CommonFilterModel = {
            'personnel.id': GridUtils.getNumberFilterModel('equals', this.personnel.id)
        }
        const params: CommonParams = {
            size: PAGINATOR_BIG_PAGE_SIZE
        }
        const response = await this.$_toCallUnique(configurationPersonnelMostLikelyMorphologicCodeAssignmentService.paginator(filterModel, params, this.state.laboratoryId))
        if (response) {
            return response.content
        }
        return []
    }

    private async _createPersonnelMostLikelyMorphologicCodeAssignment(createRequest: ConfigurationPersonnelMostLikelyMorphologicCodeAssignmentCreateRequest): Promise<ConfigurationPersonnelMostLikelyMorphologicCodeAssignmentResponse | null> {
        const response = await this.$_toCallUnique(configurationPersonnelMostLikelyMorphologicCodeAssignmentService.create(this.state.laboratoryId, createRequest))
        if (response) {
            this.$_showToastSuccess(this.$t('configuration.toastMessages.created')?.toString())
            return response
        }
        return null
    }

    private async _deletePersonnelMostLikelyMorphologicCodeAssignment(personnelMostLikelyMorphologicCodeAssignmentId: number): Promise<void> {
        if (personnelMostLikelyMorphologicCodeAssignmentId) {
            await this.$_toCallUnique(configurationPersonnelMostLikelyMorphologicCodeAssignmentService.delete(personnelMostLikelyMorphologicCodeAssignmentId, this.state.laboratoryId))
            this.$_showToastSuccess(this.$tc('configuration.toastMessages.deleted', 1))
        }
    }

    /// FORM OPERATIONS ///

    async createOperation(mostLikelyMorphologicCode: CommonMostLikelyMorphologicCodeResponse): Promise<void> {
        if (mostLikelyMorphologicCode) {
            const createRequest: ConfigurationPersonnelMostLikelyMorphologicCodeAssignmentCreateRequest = {
                personnelId: this.personnel.id,
                mostLikelyMorphologicCodeId: mostLikelyMorphologicCode.id
            }
            if (await this._createPersonnelMostLikelyMorphologicCodeAssignment(createRequest)) {
                await this._loadPersonnelMostLikelyMorphologicCodeAssignments()
            }
        }
    }

    async deleteOperation(personnelMostLikelyMorphologicCodeAssignment: ConfigurationPersonnelMostLikelyMorphologicCodeAssignmentResponse): Promise<void> {
        if (personnelMostLikelyMorphologicCodeAssignment) {
            await this._deletePersonnelMostLikelyMorphologicCodeAssignment(personnelMostLikelyMorphologicCodeAssignment.id)
            await this._loadPersonnelMostLikelyMorphologicCodeAssignments()
        }
    }
}
